import { ClassificationMaps } from '@yourcause/common';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { SubsectionCode } from '../models/subsection-codes.model';
@RegisterYCState()
export class ClassificationState extends BaseYcState {
  classifications: ClassificationMaps;
  subsections: SubsectionCode[];
}
